export interface Page<T> {
  items: T[];
  /** 實際採用的頁碼（1 起算，已限制在合法範圍內） */
  page: number;
  pageCount: number;
  pageSize: number;
  total: number;
}

/** 前端分頁。頁碼超出範圍時夾到第一頁或最後一頁；空清單視為 1 頁。 */
export function paginate<T>(items: readonly T[], page: number, pageSize: number): Page<T> {
  const size = Number.isFinite(pageSize) && pageSize >= 1 ? Math.floor(pageSize) : 1;
  const total = items.length;
  const pageCount = Math.max(1, Math.ceil(total / size));
  const p = Number.isFinite(page) ? Math.min(Math.max(1, Math.floor(page)), pageCount) : 1;
  const start = (p - 1) * size;
  return { items: items.slice(start, start + size), page: p, pageCount, pageSize: size, total };
}
